import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';
import {sponsorFormatPrice} from '../../../utilities/helper/SponsorFormatNumber';
import {singlePriceInput} from './type';

const SinglePriceInput = ({
  name,
  isEdit,
  value,
  min,
  plusHandler,
  minusHandler,
  setValue,
}: singlePriceInput) => {
  return (
    <div className="w-full flex items-center justify-between gap-2 border border-gray-400 relative rounded-lg p-[12px]">
      <span className="text-gray-700 text-xs absolute right-5 bg-white px-1 -top-[7.5px]">
        مبلغ پیشنهادی
      </span>
      <div
        onClick={plusHandler}
        className={`w-[22px] h-[22px] !border rounded-[3px] shrink-0 grid place-items-center ${
          isEdit
            ? '!border-gray-400 !text-gray-500'
            : value
            ? ' !border-farm-shop-500 text-farm-shop-500'
            : '!border-gray-400 !text-gray-500'
        }`}
      >
        <SpanIcon className="icon-namePlus-4 text-base" />
      </div>
      <input
        disabled={true}
        type="text"
        id={name}
        name={name}
        autoComplete={'off'}
        className={`border-0 outline-0 text-sm  bg-transparent text-center ${
          isEdit ? 'text-gray-500' : 'text-gray-800'
        }`}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setValue(e.target.value);
        }}
        value={sponsorFormatPrice(value)}
      />
      <div
        onClick={() => {
          if (value <= min) return;
          minusHandler();
        }}
        className={`w-[22px] h-[22px] !border  rounded-[3px] shrink-0 grid place-items-center ${
          isEdit
            ? '!border-gray-400 !text-gray-500'
            : value > min
            ? ' !border-farm-shop-500 text-farm-shop-500'
            : '!border-gray-400 !text-gray-500'
        }`}
      >
        <SpanIcon className="icon-nameMinus-4 text-base" />
      </div>
    </div>
  );
};

export default SinglePriceInput;
